import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPickupLocation = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	x: 0,
	y: 0,
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: ".st0{fill:#111}"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M20 0H4v16h16V0zm-2 14H6V2h12v12z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M11 7.3V12h2V7.3l1.6 1.8L16 7.7l-4-4.2-4 4.2 1.4 1.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M22 8v14H2V8H0v16h24V8z"
		})
	]
});
export default SvgPickupLocation;
